import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission } from '../utils/permissions';

const RoleGuard = ({ permission, children, fallback }) => {
  const { user } = useAuth();
  
  if (!user || !hasPermission(user.role, permission)) {
    if (fallback === null) {
      return null;
    }
    return fallback || (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        color: '#dc3545',
        background: '#f8d7da',
        borderRadius: '8px',
        margin: '20px 0'
      }}>
        <h3>Access Denied</h3>
        <p>You don't have permission to access this feature.</p>
      </div>
    );
  }
  
  return children;
};

export default RoleGuard;